// extracted by mini-css-extract-plugin
export default {"whatisContainer":"WhatIs_whatisContainer__iRjJq","whatisTitle":"WhatIs_whatisTitle__Twgd8","whatisDescription":"WhatIs_whatisDescription__G1ygj"};